import { hasPropertyCheck } from './hasPropertyCheck';

export const orderByLocale = (sortingList, array) => {
  return array.sort((firstObject, secondObject) => {
    if (hasPropertyCheck(firstObject, 'name') && hasPropertyCheck(secondObject, 'name')) {
      return sortingList.indexOf(firstObject.name) - sortingList.indexOf(secondObject.name);
    }
  });
};
